/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Southern Wind Warehouse API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HistoryEntry,
  PageShipmentListItem,
  ProblemDetail,
  ShipmentCreate,
  ShipmentDetail,
  ShipmentUpdate,
  ShipmentsListShipmentsParams,
  ShipmentsTransitionBody
} from '../../model';

import { apiRequest } from '../../../http';
import type { ErrorType , BodyType } from '../../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Отгрузки
 */
export const shipmentsListShipments = (
    params?: ShipmentsListShipmentsParams,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<PageShipmentListItem>(
      {url: `/api/v1/shipments`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getShipmentsListShipmentsQueryKey = (params?: ShipmentsListShipmentsParams,) => {
    return [
    `/api/v1/shipments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getShipmentsListShipmentsQueryOptions = <TData = Awaited<ReturnType<typeof shipmentsListShipments>>, TError = ErrorType<ProblemDetail>>(params?: ShipmentsListShipmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shipmentsListShipments>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShipmentsListShipmentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shipmentsListShipments>>> = ({ signal }) => shipmentsListShipments(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shipmentsListShipments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShipmentsListShipmentsQueryResult = NonNullable<Awaited<ReturnType<typeof shipmentsListShipments>>>
export type ShipmentsListShipmentsQueryError = ErrorType<ProblemDetail>


export function useShipmentsListShipments<TData = Awaited<ReturnType<typeof shipmentsListShipments>>, TError = ErrorType<ProblemDetail>>(
 params: undefined |  ShipmentsListShipmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shipmentsListShipments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shipmentsListShipments>>,
          TError,
          Awaited<ReturnType<typeof shipmentsListShipments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShipmentsListShipments<TData = Awaited<ReturnType<typeof shipmentsListShipments>>, TError = ErrorType<ProblemDetail>>(
 params?: ShipmentsListShipmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shipmentsListShipments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shipmentsListShipments>>,
          TError,
          Awaited<ReturnType<typeof shipmentsListShipments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShipmentsListShipments<TData = Awaited<ReturnType<typeof shipmentsListShipments>>, TError = ErrorType<ProblemDetail>>(
 params?: ShipmentsListShipmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shipmentsListShipments>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Отгрузки
 */

export function useShipmentsListShipments<TData = Awaited<ReturnType<typeof shipmentsListShipments>>, TError = ErrorType<ProblemDetail>>(
 params?: ShipmentsListShipmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shipmentsListShipments>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShipmentsListShipmentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Новый черновик
 */
export const shipmentsCreateShipment = (
    shipmentCreate: BodyType<ShipmentCreate>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<ShipmentDetail>(
      {url: `/api/v1/shipments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shipmentCreate, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getShipmentsCreateShipmentMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shipmentsCreateShipment>>, TError,{data: BodyType<ShipmentCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof shipmentsCreateShipment>>, TError,{data: BodyType<ShipmentCreate>}, TContext> => {

const mutationKey = ['shipmentsCreateShipment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shipmentsCreateShipment>>, {data: BodyType<ShipmentCreate>}> = (props) => {
          const {data} = props ?? {};

          return  shipmentsCreateShipment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ShipmentsCreateShipmentMutationResult = NonNullable<Awaited<ReturnType<typeof shipmentsCreateShipment>>>
    export type ShipmentsCreateShipmentMutationBody = BodyType<ShipmentCreate>
    export type ShipmentsCreateShipmentMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Новый черновик
 */
export const useShipmentsCreateShipment = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shipmentsCreateShipment>>, TError,{data: BodyType<ShipmentCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shipmentsCreateShipment>>,
        TError,
        {data: BodyType<ShipmentCreate>},
        TContext
      > => {

      const mutationOptions = getShipmentsCreateShipmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Карточка отгрузки со строками и партиями
 */
export const shipmentsGetShipment = (
    shipmentId: number,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<ShipmentDetail>(
      {url: `/api/v1/shipments/${shipmentId}`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getShipmentsGetShipmentQueryKey = (shipmentId?: number,) => {
    return [
    `/api/v1/shipments/${shipmentId}`
    ] as const;
    }

    
export const getShipmentsGetShipmentQueryOptions = <TData = Awaited<ReturnType<typeof shipmentsGetShipment>>, TError = ErrorType<ProblemDetail>>(shipmentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shipmentsGetShipment>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShipmentsGetShipmentQueryKey(shipmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shipmentsGetShipment>>> = ({ signal }) => shipmentsGetShipment(shipmentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shipmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shipmentsGetShipment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShipmentsGetShipmentQueryResult = NonNullable<Awaited<ReturnType<typeof shipmentsGetShipment>>>
export type ShipmentsGetShipmentQueryError = ErrorType<ProblemDetail>


export function useShipmentsGetShipment<TData = Awaited<ReturnType<typeof shipmentsGetShipment>>, TError = ErrorType<ProblemDetail>>(
 shipmentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shipmentsGetShipment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shipmentsGetShipment>>,
          TError,
          Awaited<ReturnType<typeof shipmentsGetShipment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShipmentsGetShipment<TData = Awaited<ReturnType<typeof shipmentsGetShipment>>, TError = ErrorType<ProblemDetail>>(
 shipmentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shipmentsGetShipment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shipmentsGetShipment>>,
          TError,
          Awaited<ReturnType<typeof shipmentsGetShipment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShipmentsGetShipment<TData = Awaited<ReturnType<typeof shipmentsGetShipment>>, TError = ErrorType<ProblemDetail>>(
 shipmentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shipmentsGetShipment>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Карточка отгрузки со строками и партиями
 */

export function useShipmentsGetShipment<TData = Awaited<ReturnType<typeof shipmentsGetShipment>>, TError = ErrorType<ProblemDetail>>(
 shipmentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shipmentsGetShipment>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShipmentsGetShipmentQueryOptions(shipmentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Правка черновика (version обязателен)
 */
export const shipmentsUpdateShipment = (
    shipmentId: number,
    shipmentUpdate: BodyType<ShipmentUpdate>,
 options?: SecondParameter<typeof apiRequest>,) => {
      
      
      return apiRequest<ShipmentDetail>(
      {url: `/api/v1/shipments/${shipmentId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: shipmentUpdate
    },
      options);
    }
  


export const getShipmentsUpdateShipmentMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shipmentsUpdateShipment>>, TError,{shipmentId: number;data: BodyType<ShipmentUpdate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof shipmentsUpdateShipment>>, TError,{shipmentId: number;data: BodyType<ShipmentUpdate>}, TContext> => {

const mutationKey = ['shipmentsUpdateShipment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shipmentsUpdateShipment>>, {shipmentId: number;data: BodyType<ShipmentUpdate>}> = (props) => {
          const {shipmentId,data} = props ?? {};

          return  shipmentsUpdateShipment(shipmentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ShipmentsUpdateShipmentMutationResult = NonNullable<Awaited<ReturnType<typeof shipmentsUpdateShipment>>>
    export type ShipmentsUpdateShipmentMutationBody = BodyType<ShipmentUpdate>
    export type ShipmentsUpdateShipmentMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Правка черновика (version обязателен)
 */
export const useShipmentsUpdateShipment = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shipmentsUpdateShipment>>, TError,{shipmentId: number;data: BodyType<ShipmentUpdate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shipmentsUpdateShipment>>,
        TError,
        {shipmentId: number;data: BodyType<ShipmentUpdate>},
        TContext
      > => {

      const mutationOptions = getShipmentsUpdateShipmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary История статусов
 */
export const shipmentsHistory = (
    shipmentId: number,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<HistoryEntry[]>(
      {url: `/api/v1/shipments/${shipmentId}/history`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getShipmentsHistoryQueryKey = (shipmentId?: number,) => {
    return [
    `/api/v1/shipments/${shipmentId}/history`
    ] as const;
    }

    
export const getShipmentsHistoryQueryOptions = <TData = Awaited<ReturnType<typeof shipmentsHistory>>, TError = ErrorType<ProblemDetail>>(shipmentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shipmentsHistory>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShipmentsHistoryQueryKey(shipmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shipmentsHistory>>> = ({ signal }) => shipmentsHistory(shipmentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shipmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shipmentsHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShipmentsHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof shipmentsHistory>>>
export type ShipmentsHistoryQueryError = ErrorType<ProblemDetail>


export function useShipmentsHistory<TData = Awaited<ReturnType<typeof shipmentsHistory>>, TError = ErrorType<ProblemDetail>>(
 shipmentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shipmentsHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shipmentsHistory>>,
          TError,
          Awaited<ReturnType<typeof shipmentsHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShipmentsHistory<TData = Awaited<ReturnType<typeof shipmentsHistory>>, TError = ErrorType<ProblemDetail>>(
 shipmentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shipmentsHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shipmentsHistory>>,
          TError,
          Awaited<ReturnType<typeof shipmentsHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShipmentsHistory<TData = Awaited<ReturnType<typeof shipmentsHistory>>, TError = ErrorType<ProblemDetail>>(
 shipmentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shipmentsHistory>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary История статусов
 */

export function useShipmentsHistory<TData = Awaited<ReturnType<typeof shipmentsHistory>>, TError = ErrorType<ProblemDetail>>(
 shipmentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shipmentsHistory>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShipmentsHistoryQueryOptions(shipmentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Смена статуса: резерв, отгрузка, возврат в черновик, отмена
 */
export const shipmentsTransition = (
    shipmentId: number,
    shipmentsTransitionBody: BodyType<ShipmentsTransitionBody>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<ShipmentDetail>(
      {url: `/api/v1/shipments/${shipmentId}/transitions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shipmentsTransitionBody, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getShipmentsTransitionMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shipmentsTransition>>, TError,{shipmentId: number;data: BodyType<ShipmentsTransitionBody>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof shipmentsTransition>>, TError,{shipmentId: number;data: BodyType<ShipmentsTransitionBody>}, TContext> => {

const mutationKey = ['shipmentsTransition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shipmentsTransition>>, {shipmentId: number;data: BodyType<ShipmentsTransitionBody>}> = (props) => {
          const {shipmentId,data} = props ?? {};

          return  shipmentsTransition(shipmentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ShipmentsTransitionMutationResult = NonNullable<Awaited<ReturnType<typeof shipmentsTransition>>>
    export type ShipmentsTransitionMutationBody = BodyType<ShipmentsTransitionBody>
    export type ShipmentsTransitionMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Смена статуса: резерв, отгрузка, возврат в черновик, отмена
 */
export const useShipmentsTransition = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shipmentsTransition>>, TError,{shipmentId: number;data: BodyType<ShipmentsTransitionBody>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shipmentsTransition>>,
        TError,
        {shipmentId: number;data: BodyType<ShipmentsTransitionBody>},
        TContext
      > => {

      const mutationOptions = getShipmentsTransitionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    